export default {"src":"/_next/static/media/fact_card.b83783c9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};